import { z } from 'zod';

export const AuditEventKindSchema = z.enum([
  'entity_create',
  'entity_update',
  'entity_delete',
  'auth_event',
  'deploy_event',
  'sequence_run',
  'trigger_fire',
  'annotation',
  // Plan 9 — recorded by validate-topology + the deploy gate.
  'reconciliation_run',
]);

export const AuditEventSchema = z.object({
  id: z.string().min(1),
  workspace_id: z.string().nullable(),
  project_id: z.string().nullable(),
  user_id: z.string().nullable(),
  user_email: z.string().nullable(),
  kind: AuditEventKindSchema,
  message: z.string(),
  resource_type: z.string().nullable(),
  resource_id: z.string().nullable(),
  method: z.string().nullable(),
  path: z.string().nullable(),
  status: z.number().int().min(0).max(999).nullable(),
  timestamp_ms: z.number().int().nonnegative(),
});

export const AuditQueryResponseSchema = z.object({
  events: z.array(AuditEventSchema),
  total: z.number().int().nonnegative(),
});

export type ParsedAuditEvent = z.infer<typeof AuditEventSchema>;
export type ParsedAuditEventKind = z.infer<typeof AuditEventKindSchema>;
export type ParsedAuditQueryResponse = z.infer<typeof AuditQueryResponseSchema>;
